import grey from '@material-ui/core/colors/grey';
import { makeStyles, useTheme } from '@material-ui/core/styles';

export const Theme = useTheme;

export const useStyles = makeStyles(theme => {
	return {
		showroomGridItemLabel: {
			overflow: 'hidden',
			height: 18,
			color: '#FFF'
		},
		showroomDialogAppBar: {
			position: 'relative'
		},
		dialogContent: {
			padding: 0,
			height: 'calc(100vh - 50px)',
			position: 'relative',
			[theme.breakpoints.down('sm')]: {
				height: 'calc(100vh - 36px)'
			}
		},
		showroomDialogTitle: {
			paddingBottom: 0,
			marginLeft: 20,
			flex: 1
		},
		showroomDialogBackButton: {
			fontSize: 18
		},
		showroomDialogCloseButton: {
			background: 'black !important',
			borderRadius: 0,
			color: '#FFF'
		},
		dialogTitle: {
			padding: 0
		},
		zoomToolbar: {
			minHeight: 50,
			paddingLeft: 55,
			paddingRight: 0,
			transform: 'none',
			[theme.breakpoints.down('sm')]: {
				minHeight: 36,
				paddingLeft: 0
			}
		},
		zoomLogo: {
			marginRight: 10,
			marginLeft: 10
		},
		fullLogo: {
			flexGrow: 1,
			marginRight: 0
		},
		zoomLogoImg: {
			width: 115,
			height: 45,
			objectFit: 'contain',
			[theme.breakpoints.down('sm')]: {
				height: 30
			}
		},
		showroomZoomArrowIcon: {
			fontSize: 20,
			[theme.breakpoints.down('sm')]: {
				fontSize: 11
			}
		},
		showroomZoomCloseIcon: {
			fontSize: 26,
			[theme.breakpoints.down('sm')]: {
				fontSize: 12
			}
		},
		currentImageLabel: {
			fontSize: 16,
			fontWeight: 'bold',
			flexGrow: 1,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap'
		},
		showroomZoomArrowButton: {
			color: 'black',
			alignSelf: 'stretch',
			background: grey[200],
			borderRadius: 0
		},
		previewHeader: {
			background: 'white',
			boxShadow: 'none'
		},
		previewHeaderResponsive: {
			padding: '0 10px 0'
		},
		swipeableWrapper: {
			height: '100%',
			width: '100%',
			position: 'absolute'
		},
		swipeableSlide: {
			display: 'flex',
			height: '100%',
			width: '100%'
		}
	};
});
